import { cn } from '@/shared/utils/cn';
import { CustomizationChip, CustomizationRowLabel } from './CustomizationChip';

interface CustomizationOptionRowProps {
  label: string;
  options: Array<{ value: string; label: string }>;
  activeValue: string | number | undefined;
  onSelect: (value: string) => void;
  isFirst?: boolean;
}

export function CustomizationOptionRow({
  label,
  options,
  activeValue,
  onSelect,
  isFirst = false,
}: CustomizationOptionRowProps) {
  if (options.length === 0) return null;

  return (
    <div
      className={cn(
        'border-b border-[#ededed] mb-1.5 last:mb-0',
        isFirst && 'border-t border-[#ededed]'
      )}
    >
      <div className="flex w-full">
        <CustomizationRowLabel label={label} />
        <div className="min-w-0 flex-1 overflow-x-auto px-[9px] pb-1.5 pt-3">
          <ul className="flex gap-1">
            {options.map((option) => {
              const isSelected = String(activeValue) === option.value;
              return (
                <li key={option.value}>
                  <CustomizationChip
                    selected={isSelected}
                    onClick={() => onSelect(option.value)}
                  >
                    {option.label}
                  </CustomizationChip>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}
